import { Component, Mixins } from 'vue-property-decorator'
import AuthMixin from '../mixins/AuthMixin.vue'
import IconsMixin from '../mixins/IconsMixin.vue'

import { routerOptions } from '@/router'
import RestaurantNavBar from '../views/Restaurant/NavBar'
import VendorNavBar from '../views/Vendor/NavBar'
import AdminNavBar from '../views/Admin/Navbar'
import ApplicationAdminNavBar from '../views/ApplicationAdmin/Navbar'
import RestaurantSwitcher from '@/components/Company/RestaurantSwitcher.vue'
import UserCompaniesMixin from '../mixins/UserCompaniesMixin.vue'
import { getHome } from '@/services/navigation.service'
import BrandLogo from '@/components/BrandLogo.vue'
import NavbarItem from './NavbarItem.vue'

interface NavItem {
  title: string,
  icon?: string,
  nav?: string,
  items?: NavItem[]
}

@Component({
  components: {
    RestaurantSwitcher,
    BrandLogo,
    NavbarItem
  }
})
export default class DefaultLayout extends Mixins(AuthMixin, IconsMixin, UserCompaniesMixin) {
  public showDrawer: boolean = true
  public displayCompanyNameText: boolean = false

  public get sidebar() {
    if (this.isAdmin) {
      return this.generateNavItems(AdminNavBar)
    } else if (this.isRestaurant) {
      return this.generateNavItems(RestaurantNavBar)
    } else if (this.isVendor) {
      return this.generateNavItems(VendorNavBar)
    }
  }

  public get accountingNavs() {
    if (this.isRestaurant) {
      return this.filterAccountingNav(RestaurantNavBar)
    } else {
      return []
    }
  }

  public profileDisplay() {
    if (this.userClaim && this.userClaim.name) {
      return this.userClaim.name
    }

    if (this.user) {
      return this.user.email || this.user.phoneNumber
    }

    return ''
  }

  public async redirect(name: string) {
    try {
      await this.$router.push({name})
    } catch (e) {
    }
  }

  public async redirectHome() {
    try {
      await this.$router.push({name: getHome(this.userCompany.type)})
    } catch (e) {
    }
  }

  public async logout() {
    await (await this.$firebase).auth().signOut()
    await this.$router.push({name: 'login'})
  }

  private generateNavItems(navs: NavItem[]): NavItem[] {
    if (this.isApplicationAdmin || this.isReadOnlyAdmin) {
      navs = [...ApplicationAdminNavBar, ...navs]
    }

    return this.filterNav(navs)
  }

  private filterNav(navs: NavItem[]): NavItem[] {
    const routes = routerOptions.routes || []
    const userCompanyUserRole = this.userCompany.userRole
    const userCompanyType = this.userCompany.type

    return navs.filter(navItem => {
      if (navItem.items) {
        navItem.items = this.filterNav(navItem.items)
        return navItem.items && !!navItem.items.length
      }

      if (navItem.nav) {
        const route = routes.find(r => r.name === navItem.nav)

        if (route) {
          if (route.meta) {
            const meta = route.meta

            if (
              meta.roles
              && meta.roles.length
              && !meta.roles.includes(userCompanyUserRole)
              && !this.isReadOnlyAdmin
              && !this.isAdminForRestaurant
            ) {
              return false
            }

            if (
              meta.companyTypes
              && meta.companyTypes.length
              && !meta.companyTypes.includes(userCompanyType)
            ) {
              return false
            }
          }

          return true
        }

        return false
      }

      return true
    })
      .filter((item, index, arr) =>
        // filter out any section headers that don't have any items
        !item.nav &&
        !item.items &&
        (index === arr.length - 1 || (!arr[index + 1].nav && !arr[index + 1].items))
          ? false
          : true
      )
  }

  private filterAccountingNav(navs: any[]) {
    return navs.filter(navItem => navItem.accounting)
  }
}
